module.exports = __webpack_public_path__ + "img/174-denmark.63c806e6.svg";